export default __webpack_public_path__ + "static/media/46t.737267ad.jpg";